/* Configuratore grafiche Binni Design - INTERFACCIA.
   Motore colori: configuratore-colori.js
   Marche e taratura: configuratore-marche.js
   Cilindrata / finitura e prezzi: configuratore-scelte.js
   Supplementi e carrello: configuratore-carrello.js

   Il configuratore vende la GRAFICA SCELTA con le sue varianti vere:
   il prezzo e quello della semi-personalizzata e sulle motard il cliente
   deve dire se la moto sta fino a 450 cc o oltre. */
(function () {
  var MAX_SPONSOR = 6;
  var MAX_CARATTERI = 6;
  var MAX_NOTE = 800;

  function avvia() {
    var radice = document.getElementById('bc2');
    if (!radice || radice.dataset.pronto) return;
    var M = window.BC_COLORI, S = window.BC_SCELTE;
    if (!M || !S) return;
    radice.dataset.pronto = '1';

    function $(id) { return document.getElementById(id); }

    (function css() {
      if (document.getElementById('bcCssColori')) return;
      var s = document.createElement('style');
      s.id = 'bcCssColori';
      s.textContent = [
        '#bc2 .bc-swatch-orig{width:26px;height:26px;border:2px solid #000;flex-shrink:0;padding:0;cursor:pointer;}',
        '#bc2 .bc-swatch-orig:hover{outline:2px solid var(--lime);outline-offset:2px;}',
        '#bc2 .bc-reset{width:100%;font:inherit;font-size:1.25rem;font-weight:800;letter-spacing:.06em;',
        'text-transform:uppercase;padding:13px 16px;cursor:pointer;background:none;border:2px solid #000;color:#000;}',
        '#bc2 .bc-reset:hover{background:#000;color:#fff;}',
        '#bc2 [hidden]{display:none !important;}',
        '#bc2 #bcImg{cursor:crosshair;}',
        '#bc2 .bc-suggerimento{font-size:1.3rem;line-height:1.5;margin:0;padding:10px 12px;border:2px dashed #000;background:#fff;}',
        '#bc2 .bc-pezzo{border:3px solid #000;background:#fff;padding:14px 16px;display:none;flex-direction:column;gap:10px;}',
        '#bc2 .bc-pezzo.visibile{display:flex;}',
        '#bc2 .bc-pezzo-tit{font-size:1.3rem;font-weight:900;text-transform:uppercase;letter-spacing:.05em;margin:0;}',
        '#bc2 .bc-pezzo-riga{display:flex;flex-wrap:wrap;gap:10px;align-items:center;}',
        '#bc2 .bc-pezzo input[type=color]{width:86px;height:46px;flex:0 0 auto;}',
        '#bc2 .bc-pezzo button{font:inherit;font-size:1.2rem;font-weight:800;letter-spacing:.05em;text-transform:uppercase;',
        'padding:12px 14px;cursor:pointer;background:none;border:2px solid #000;color:#000;}',
        '#bc2 .bc-pezzo button:hover{background:#000;color:#fff;}'
      ].join('');
      document.head.appendChild(s);
    })();

    var COLLECTIONS = (window.BC_COLLECTIONS && window.BC_COLLECTIONS.length) ? window.BC_COLLECTIONS : [
      { handle: 'grafiche-hm-personalizzate-50-e-125', label: 'HM', conv: ['VENT', 'HONDA', 'CRM'] }
    ];

    var perMarca = {};
    var activeBrand = COLLECTIONS[0].label;
    var originale = null, gruppi = [], dove = null, pezzi = [], srcL = null;
    var coloriOra = [], coloriPartenza = [], colorePezzo = [], inputColori = [];
    var titoloProdotto = '', pezzoScelto = -1;

    var materiale = $('bcMaterial');
    var scritta = $('bcScritta'), boxScritta = $('bcBoxScritta');
    var logo = $('bcLogo');
    var usaNome = $('bcUsaNome'), boxNome = $('bcBoxNome'), campoNome = $('bcNome');
    var usaNumero = $('bcUsaNumero'), boxNumero = $('bcBoxNumero'), campoNumero = $('bcNumero');
    var sponsor = $('bcSponsor'), contaSponsor = $('bcContaSponsor');
    var note = $('bcNote'), contaNote = $('bcContaNote');

    function updatePrice() {
      var p = S.prezzo();
      $('bcPriceOut').textContent = p > 0 ? '€ ' + p.toFixed(2).replace('.', ',') : '—';
    }
    materiale.addEventListener('change', updatePrice);

    function caricaMarca(label) {
      var c = COLLECTIONS.filter(function (x) { return x.label === label; })[0];
      if (!c) return Promise.resolve([]);
      if (Array.isArray(perMarca[label])) return Promise.resolve(perMarca[label]);
      return fetch('/collections/' + c.handle + '/products.json?limit=50')
        .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
        .then(function (data) {
          perMarca[label] = (data.products || []).map(function (p) {
            return {
              title: p.title,
              handle: p.handle,
              image: p.images && p.images[0] ? p.images[0].src : '',
              variants: p.variants || []
            };
          }).filter(function (p) { return p.image; });
          return perMarca[label];
        })
        .catch(function () { perMarca[label] = 'errore'; return 'errore'; });
    }

    function renderTabs() {
      var tabs = $('bcTabs');
      tabs.innerHTML = '';
      COLLECTIONS.forEach(function (c) {
        if (Array.isArray(perMarca[c.label]) && perMarca[c.label].length === 0) return;
        var b = document.createElement('div');
        b.className = 'bc-tab' + (c.label === activeBrand ? ' active' : '');
        b.textContent = c.label;
        b.addEventListener('click', function () {
          activeBrand = c.label;
          renderTabs(); renderThumbs(); renderConvogliatore();
        });
        tabs.appendChild(b);
      });
    }

    function renderThumbs() {
      var wrap = $('bcThumbs');
      var dati = perMarca[activeBrand];
      if (dati === undefined) {
        wrap.innerHTML = '<div class="bc-spinner">Caricamento modelli...</div>';
        var chiesta = activeBrand;
        caricaMarca(chiesta).then(function () { if (activeBrand === chiesta) { renderTabs(); renderThumbs(); } });
        return;
      }
      if (dati === 'errore') {
        wrap.innerHTML = '<div class="bc-spinner">Non sono riuscito a caricare questa marca. Riclicca sulla linguetta.</div>';
        perMarca[activeBrand] = undefined;
        return;
      }
      if (!dati.length) { wrap.innerHTML = '<div class="bc-spinner">Nessun modello disponibile.</div>'; return; }
      wrap.innerHTML = '';
      dati.forEach(function (p) {
        var el = document.createElement('div');
        el.className = 'bc-thumb';
        var img = document.createElement('img');
        img.src = p.image; img.loading = 'lazy';
        var sp = document.createElement('span');
        sp.textContent = p.title.replace(/^Grafiche [A-Za-z0-9\/ ]+ Personalizzate\s*[–-]\s*/, '');
        el.appendChild(img); el.appendChild(sp);
        el.addEventListener('click', function () { scegliProdotto(p, el); });
        wrap.appendChild(el);
      });
    }

    function renderConvogliatore() {
      var c = COLLECTIONS.filter(function (x) { return x.label === activeBrand; })[0];
      var voci = (c ? c.conv : []).concat(['Nessuna', 'La scrivo io']);
      var box = $('bcScelteConv');
      box.innerHTML = '';
      voci.forEach(function (v) {
        var lab = document.createElement('label');
        lab.className = 'bc-scelta';
        var inp = document.createElement('input');
        inp.type = 'radio'; inp.name = 'bcConv'; inp.value = v;
        if (v === 'Nessuna') inp.checked = true;
        inp.addEventListener('change', aggiornaScritta);
        var sp = document.createElement('span');
        sp.textContent = v;
        lab.appendChild(inp); lab.appendChild(sp);
        box.appendChild(lab);
      });
      aggiornaScritta();
    }

    function convScelta() {
      var s = document.querySelector('input[name="bcConv"]:checked');
      return s ? s.value : 'Nessuna';
    }
    function aggiornaScritta() {
      var attiva = convScelta() === 'La scrivo io';
      boxScritta.classList.toggle('visibile', attiva);
      scritta.disabled = !attiva;
      if (!attiva) scritta.value = '';
    }
    function apriCampo(spunta, box, campo) {
      var attivo = spunta.checked;
      box.classList.toggle('visibile', attivo);
      campo.disabled = !attivo;
      if (!attivo) campo.value = '';
    }
    function sponsorElenco() {
      return (sponsor.value || '').split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s.length; });
    }
    function aggiornaSponsor() {
      var n = sponsorElenco().length;
      contaSponsor.textContent = n + ' sponsor su ' + MAX_SPONSOR;
      contaSponsor.classList.toggle('troppi', n > MAX_SPONSOR);
    }
    function aggiornaNote() {
      if (!note || !contaNote) return;
      if (note.value.length > MAX_NOTE) note.value = note.value.slice(0, MAX_NOTE);
      contaNote.textContent = note.value.length + ' / ' + MAX_NOTE + ' caratteri';
    }

    scritta.addEventListener('input', function () {
      scritta.value = scritta.value.toUpperCase().replace(/[^A-Z0-9 ]/g, '').slice(0, MAX_CARATTERI);
    });
    campoNumero.addEventListener('input', function () {
      campoNumero.value = campoNumero.value.replace(/[^0-9]/g, '').slice(0, 4);
    });
    usaNome.addEventListener('change', function () { apriCampo(usaNome, boxNome, campoNome); });
    usaNumero.addEventListener('change', function () { apriCampo(usaNumero, boxNumero, campoNumero); });
    sponsor.addEventListener('input', aggiornaSponsor);
    if (note) note.addEventListener('input', aggiornaNote);

    function scegliProdotto(p, el) {
      Array.prototype.forEach.call(document.querySelectorAll('#bcThumbs .bc-thumb'), function (t) { t.classList.remove('active'); });
      if (el) el.classList.add('active');
      titoloProdotto = p.title;
      S.prepara(p);
      updatePrice();
      var stage = $('bcCanvasWrap');
      stage.innerHTML = '<div class="bc-spinner">Caricamento anteprima...</div>';
      chiudiPezzo();
      M.carica(p.image).then(function (orig) {
        originale = orig;
        var res = M.analizza(orig, p.title);
        dove = res.dove; pezzi = res.pezzi; gruppi = res.gruppi; srcL = res.srcL;
        colorePezzo = pezzi.map(function (pz) { return pz.colOrig; });
        coloriPartenza = gruppi.map(function (g) { return g.colore; });
        coloriOra = coloriPartenza.slice();
        costruisciControlli();
        disegna();
        $('bcAddToCart').disabled = false;
        $('bcAddToCart').textContent = 'Aggiungi al Carrello — Invia la tua Grafica';
      }).catch(function () {
        stage.innerHTML = '<div class="bc-placeholder">Impossibile caricare questa immagine, prova un altro modello.</div>';
      });
    }

    function applicaGruppo(idx, hex) {
      if (!gruppi[idx]) return;
      gruppi[idx].pezzi.forEach(function (k) { colorePezzo[k] = hex; });
    }

    function ripristina() {
      coloriOra = coloriPartenza.slice();
      colorePezzo = pezzi.map(function (pz) { return pz.colOrig; });
      inputColori.forEach(function (o, i) {
        o.input.value = coloriOra[i];
        o.quadri.textContent = M.cmyk(coloriOra[i]);
      });
      chiudiPezzo();
      disegna();
    }

    function costruisciControlli() {
      var box = $('bcColorControls');
      box.innerHTML = '';
      inputColori = [];
      if (!gruppi.length) {
        box.innerHTML = '<p class="bc-note">Su questa grafica non ci sono aree di colore da cambiare: bianco, nero e contorni restano sempre come sono.</p>';
        return;
      }
      gruppi.forEach(function (g, idx) {
        var field = document.createElement('div');
        field.className = 'bc-field';

        var label = document.createElement('label');
        label.textContent = 'Colore ' + (idx + 1) + ' — ' + g.label;
        field.appendChild(label);

        var row = document.createElement('div');
        row.className = 'bc-color-item';
        var swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'bc-swatch-orig';
        swatch.title = 'Rimetti il colore di partenza';
        swatch.setAttribute('aria-label', 'Rimetti il colore di partenza');
        swatch.style.background = coloriPartenza[idx];
        var input = document.createElement('input');
        input.type = 'color';
        input.value = coloriOra[idx];
        var quadri = document.createElement('p');
        quadri.className = 'bc-cmyk';
        quadri.textContent = M.cmyk(coloriOra[idx]);

        input.addEventListener('input', function () {
          coloriOra[idx] = input.value;
          quadri.textContent = M.cmyk(input.value);
          applicaGruppo(idx, input.value);
          disegna();
        });
        swatch.addEventListener('click', function () {
          coloriOra[idx] = coloriPartenza[idx];
          input.value = coloriPartenza[idx];
          quadri.textContent = M.cmyk(coloriPartenza[idx]);
          gruppi[idx].pezzi.forEach(function (k) { colorePezzo[k] = pezzi[k].colOrig; });
          disegna();
        });

        inputColori.push({ input: input, quadri: quadri });
        row.appendChild(swatch); row.appendChild(input);
        field.appendChild(row); field.appendChild(quadri);
        box.appendChild(field);
      });

      var aiuto = document.createElement('p');
      aiuto.className = 'bc-suggerimento';
      aiuto.textContent = 'Vuoi cambiare un pezzo solo? Clicca direttamente su quel pezzo nell\'anteprima. Bianco, nero e contorni restano sempre come sono.';
      box.appendChild(aiuto);

      var reset = document.createElement('button');
      reset.type = 'button';
      reset.className = 'bc-reset';
      reset.textContent = 'Ripristina i colori originali';
      reset.addEventListener('click', ripristina);
      box.appendChild(reset);
    }

    var boxPezzo = null, inputPezzo = null, cmykPezzo = null, titoloPezzo = null;

    function creaBoxPezzo() {
      if (boxPezzo) return boxPezzo;
      var stage = document.querySelector('#bc2 .bc-stage');
      if (!stage) return null;
      boxPezzo = document.createElement('div');
      boxPezzo.className = 'bc-pezzo';

      titoloPezzo = document.createElement('p');
      titoloPezzo.className = 'bc-pezzo-tit';
      titoloPezzo.textContent = 'Pezzo selezionato';
      boxPezzo.appendChild(titoloPezzo);

      var riga = document.createElement('div');
      riga.className = 'bc-pezzo-riga';

      inputPezzo = document.createElement('input');
      inputPezzo.type = 'color';
      inputPezzo.addEventListener('input', function () {
        if (pezzoScelto < 0) return;
        colorePezzo[pezzoScelto] = inputPezzo.value;
        cmykPezzo.textContent = M.cmyk(inputPezzo.value);
        disegna();
      });
      riga.appendChild(inputPezzo);

      var tutti = document.createElement('button');
      tutti.type = 'button';
      tutti.textContent = 'Tutti i pezzi di questo colore';
      tutti.addEventListener('click', function () {
        if (pezzoScelto < 0) return;
        var g = pezzi[pezzoScelto].cluster;
        applicaGruppo(g, inputPezzo.value);
        coloriOra[g] = inputPezzo.value;
        if (inputColori[g]) {
          inputColori[g].input.value = inputPezzo.value;
          inputColori[g].quadri.textContent = M.cmyk(inputPezzo.value);
        }
        disegna();
      });
      riga.appendChild(tutti);

      var rimetti = document.createElement('button');
      rimetti.type = 'button';
      rimetti.textContent = 'Rimetti l\'originale';
      rimetti.addEventListener('click', function () {
        if (pezzoScelto < 0) return;
        colorePezzo[pezzoScelto] = pezzi[pezzoScelto].colOrig;
        inputPezzo.value = pezzi[pezzoScelto].colOrig;
        cmykPezzo.textContent = M.cmyk(inputPezzo.value);
        disegna();
      });
      riga.appendChild(rimetti);

      var chiudi = document.createElement('button');
      chiudi.type = 'button';
      chiudi.textContent = 'Chiudi';
      chiudi.addEventListener('click', chiudiPezzo);
      riga.appendChild(chiudi);

      boxPezzo.appendChild(riga);

      cmykPezzo = document.createElement('p');
      cmykPezzo.className = 'bc-cmyk';
      boxPezzo.appendChild(cmykPezzo);

      stage.appendChild(boxPezzo);
      return boxPezzo;
    }

    function chiudiPezzo() {
      pezzoScelto = -1;
      if (boxPezzo) boxPezzo.classList.remove('visibile');
    }

    function apriPezzo(k) {
      creaBoxPezzo();
      if (!boxPezzo) return;
      pezzoScelto = k;
      var g = pezzi[k].cluster;
      titoloPezzo.textContent = 'Pezzo selezionato — fa parte del Colore ' + (g + 1) +
        (gruppi[g] ? ' (' + gruppi[g].label + ')' : '');
      inputPezzo.value = colorePezzo[k];
      cmykPezzo.textContent = M.cmyk(colorePezzo[k]);
      boxPezzo.classList.add('visibile');
    }

    function trovaPezzo(x, y) {
      if (!dove || !originale) return -1;
      var w = originale.canvas.width, h = originale.canvas.height;
      for (var r = 0; r <= 12; r++) {
        for (var dy = -r; dy <= r; dy++) {
          for (var dx = -r; dx <= r; dx++) {
            if (r > 0 && Math.abs(dx) !== r && Math.abs(dy) !== r) continue;
            var xx = x + dx, yy = y + dy;
            if (xx < 0 || yy < 0 || xx >= w || yy >= h) continue;
            var k = dove[yy * w + xx];
            if (k >= 0) return k;
          }
        }
      }
      return -1;
    }

    function disegna() {
      var canvas = M.ricolora(originale, dove, pezzi, colorePezzo, srcL);
      var wrap = $('bcCanvasWrap');
      wrap.innerHTML = '';
      var img = document.createElement('img');
      img.id = 'bcImg';
      img.src = canvas.toDataURL('image/png');
      img.title = 'Clicca su un pezzo per cambiare solo quel pezzo';
      img.addEventListener('click', function (e) {
        var r = img.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var x = Math.round((e.clientX - r.left) / r.width * originale.canvas.width);
        var y = Math.round((e.clientY - r.top) / r.height * originale.canvas.height);
        var k = trovaPezzo(x, y);
        if (k < 0) { chiudiPezzo(); return; }
        apriPezzo(k);
      });
      wrap.appendChild(img);
    }

    $('bcAddToCart').addEventListener('click', function () {
      if (!originale) return;
      var btn = this, stato = $('bcStatus');
      var modelloEl = $('bcModello'), telEl = $('bcTelefono'), partiEl = $('bcParti');
      var modello = modelloEl.value.trim(), tel = telEl.value.trim();

      function blocca(msg, campo) {
        stato.className = 'bc-status err';
        stato.textContent = msg;
        if (campo) { campo.focus(); campo.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }

      var problema = S.manca();
      if (problema) return blocca(problema, S.campoTipo());
      var variante = S.variante();

      modelloEl.classList.toggle('bc-invalid', !modello);
      telEl.classList.toggle('bc-invalid', !tel);
      if (!modello || !tel) return blocca('Inserisci modello e anno della moto e telefono prima di aggiungere al carrello.', modello ? telEl : modelloEl);
      if (convScelta() === 'La scrivo io' && !scritta.value.trim()) return blocca('Hai scelto di scrivere tu la scritta sul convogliatore, ma il campo è vuoto.', scritta);
      if (usaNome.checked && !campoNome.value.trim()) return blocca('Hai chiesto il nome sulla grafica, ma non hai scritto quale.', campoNome);
      if (usaNumero.checked && !campoNumero.value.trim()) return blocca('Hai chiesto il numero di gara, ma non hai scritto quale.', campoNumero);
      var ns = sponsorElenco().length;
      if (ns > MAX_SPONSOR) return blocca('Hai scritto ' + ns + ' sponsor: il massimo è ' + MAX_SPONSOR + '.', sponsor);

      btn.disabled = true;
      stato.className = 'bc-status';
      stato.textContent = 'Aggiunta in corso...';

      var props = { 'Grafica Base': titoloProdotto, 'Marca': activeBrand };
      var tipo = S.etichettaTipo();
      if (tipo) props[S.nomeTipo()] = tipo;
      gruppi.forEach(function (g, idx) {
        var uguale = (coloriOra[idx] || '').toLowerCase() === (coloriPartenza[idx] || '').toLowerCase();
        props['Colore ' + (idx + 1) + ' (' + g.label + ')'] =
          coloriOra[idx].toUpperCase() + '  ·  ' + M.cmyk(coloriOra[idx]) + (uguale ? '  (come l\'originale)' : '');
      });

      var ritocchi = [];
      pezzi.forEach(function (pz, k) {
        var suo = (colorePezzo[k] || '').toLowerCase();
        var gen = (coloriOra[pz.cluster] || '').toLowerCase();
        var orig = (pz.colOrig || '').toLowerCase();
        if (suo !== gen && suo !== orig) {
          ritocchi.push('pezzo ' + (k + 1) + ' (Colore ' + (pz.cluster + 1) + '): ' +
            colorePezzo[k].toUpperCase() + ' · ' + M.cmyk(colorePezzo[k]));
        }
      });
      if (ritocchi.length) props['Pezzi cambiati singolarmente'] = ritocchi.join(' | ');

      props['Bianco, nero e contorni'] = 'Invariati, come nella grafica originale';
      props['Scritta sul convogliatore'] = convScelta();
      if (convScelta() === 'La scrivo io') props['Scritta personalizzata'] = scritta.value.trim();
      props['Logo marca moto'] = logo.checked ? 'Sì' : 'No';
      if (usaNome.checked) props['Nome sulla grafica'] = campoNome.value.trim();
      if (usaNumero.checked) props['Numero di gara'] = campoNumero.value.trim();
      if (sponsorElenco().length) props['Sponsor'] = sponsorElenco().join(', ');
      props['Modello e anno della moto:'] = modello;
      props['Telefono'] = tel;
      if (partiEl.value.trim()) props['Parti non originali'] = partiEl.value.trim();
      if (note && note.value.trim()) props['Note per il grafico'] = note.value.trim();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1, properties: props }] })
      }).then(function (r) { if (!r.ok) throw new Error('err'); return r.json(); })
        .then(function () {
          stato.className = 'bc-status ok';
          stato.textContent = 'Aggiunto al carrello! Vai al carrello per completare l\'ordine.';
          btn.disabled = false;
        }).catch(function () {
          stato.className = 'bc-status err';
          stato.textContent = 'Errore, riprova o scrivici.';
          btn.disabled = false;
        });
    });

    S.prepara(null);
    updatePrice();
    apriCampo(usaNome, boxNome, campoNome);
    apriCampo(usaNumero, boxNumero, campoNumero);
    aggiornaSponsor();
    aggiornaNote();
    renderTabs();
    renderThumbs();
    renderConvogliatore();
  }

  var tentativi = 0;
  var attesa = setInterval(function () {
    tentativi++;
    if ((window.BC_COLORI && window.BC_SCELTE) || tentativi > 100) { clearInterval(attesa); avvia(); }
  }, 60);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
